import React, { Component, Fragment } from "react";
import * as PropTypes from "prop-types";
import axios from "axios";
import { Col, Form, Input, Spin, message, Modal, Checkbox, Row, Select, Typography } from "antd";
import { debounce } from "lodash";

import { API_ERRO_TYPE_CANCEL } from "./../../config/general";
import { tones } from "./../../config/theme";

import { timeService, overtimeService, dsrService } from "../../redux/services";

import moment from "moment";

import {
	DatePickerWithMask,
	UIDrawerForm,
	UIFormSection,
} from "./../../components";

import UIKpiCards from "./../../components/KpiCards";

import DayTable from "./table";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

const { TextArea } = Input;

export const TIME_TYPES = {
	semanal: { label: "Semanal", tone: "primary", description: "Horário baseado em dias da semana." },
	escala : { label: "Escala", tone: "success", description: "Horário baseado em escala de trabalho." },
};

const formatMinutes = (minutes) => `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;

export const getTracksSummary = (tracks) => {
	const worked = tracks.filter((track) => track.carga_horaria && track.carga_horaria !== "00:00");

	return {
		minutes: Math.round(worked.reduce((total, track) => total + moment.duration(track.carga_horaria).asMinutes(), 0)),
		worked: worked.length,
		off: tracks.filter((track) => track.tipo === "folga").length,
	};
};

export const TimeSummary = ({ summary, isEscala, toleranciaExtra, toleranciaFalta }) => (
	<UIKpiCards
		items={[
			{
				key  : "workload",
				tone : "blue",
				icon : <i className="fal fa-clock" />,
				title: isEscala ? "Carga horária da escala" : "Carga horária semanal",
				value: formatMinutes(summary.minutes),
			},
			{
				key  : "worked",
				tone : "violet",
				icon : <i className="fal fa-calendar-check" />,
				title: isEscala ? "Ciclos trabalhados" : "Dias trabalhados",
				value: summary.worked,
			},
			{
				key  : "off",
				tone : "green",
				icon : <i className="fal fa-calendar-times" />,
				title: isEscala ? "Ciclos de folga" : "Dias de folga",
				value: summary.off,
			},
			{
				key    : "tolerance",
				tone   : "amber",
				icon   : <i className="fal fa-stopwatch" />,
				title  : "Tolerância diária",
				value  : `${toleranciaExtra}/${toleranciaFalta}`,
				caption: "Minutos de extras / faltas",
			},
		]}
	/>
);

export const TimeTypeField = ({ value, onChange }) => (
	<Row gutter={[12, 12]}>
		{Object.entries(TIME_TYPES).map(([key, type]) => (
			<Col xs={24} sm={12} key={key}>
				<div
					className={`byp-role-option ${value === key ? "byp-role-option-selected" : ""}`}
					onClick={() => value !== key && onChange(key)}>
					<span className="byp-role-option-icon" style={{ backgroundColor: tones[type.tone].background, color: tones[type.tone].color }}>
						<i className="fal fa-clock" />
					</span>
					<span className="byp-role-option-text">
						<span className="byp-role-option-name">{type.label}</span>
						<span className="byp-role-option-description">{type.description}</span>
					</span>
				</div>
			</Col>
		))}
	</Row>
);

class Create extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};


	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isSending: false,
			hasHourError: false,
			nextOrder: 1,
			type: null,
			tracksAmount: 1,

			dsrIsLoading: false,
			dsr: [],
			overtimeIsLoading: false,
			overtime: [],

			intervals: [],

			fixar_tolerancia: true,
			tolerancia_extra: 10,
			tolerancia_falta: 10,
			tipo_calculo: null,
			tipo_horario: 'semanal',

			summary: {
				minutes: 0,
				worked: 0,
				off: 0,
			},
		};

		this._axiosCancelOvertimeToken = null;
		this._axiosCancelDsrToken = null;
	}

	onOpen = () => {
		this.setState({
			fixar_tolerancia: true,
		});

		setTimeout(() => {
			this.descricao && this.descricao.focus()
			this.form.setFieldsValue({
				status: "Ativo",
			});
		}, 100)
	};

	fetchOvertime = (value) => {
		if (this._axiosCancelOvertimeToken) {
			this._axiosCancelOvertimeToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelOvertimeToken = axios.CancelToken.source();

		// if (value !== undefined && !value.trim().length) {
			// this.setState({
				// overtimeIsLoading: false,
				// overtime: [],
			// });

			// return false;
		// }

		this.setState({
			overtimeIsLoading: true,
		});

		overtimeService.getAll({
			...(value ? { search: value } : {}),
			// orderBy: "name:asc",
			cancelToken: this._axiosCancelOvertimeToken.token,
		})
			.then((response) => {
				this.setState({
					overtimeIsLoading: false,
					overtime: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					overtimeIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchOvertimeSearch = debounce(this.fetchOvertime, 500);

	fetchDsr = (value) => {
		if (this._axiosCancelDsrToken) {
			this._axiosCancelDsrToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelDsrToken = axios.CancelToken.source();

		// if (value !== undefined && !value.trim().length) {
			// this.setState({
				// dsrIsLoading: false,
				// dsr: [],
			// });

			// return false;
		// }

		this.setState({
			dsrIsLoading: true,
		});

		dsrService.getAll({
			...(value ? { search: value } : {}),
			// orderBy: "name:asc",
			cancelToken: this._axiosCancelDsrToken.token,
		})
			.then((response) => {
				this.setState({
					dsrIsLoading: false,
					dsr: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					dsrIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchDsrSearch = debounce(this.fetchDsr, 500);

	onChangeTolerancia = (e) => {
		if(e.target.checked) {
			this.onResetToleranciaExtraAndFalta();
			this.onResetToleranciaBatidaExtraFalta();
		}
		
		this.setState({
			fixar_tolerancia: e.target.checked,
		});
	}

	onResetToleranciaExtraAndFalta() {
		const DEFAULT_VALUE = 10;
		
		this.setState({
			tolerancia_extra: DEFAULT_VALUE,
			tolerancia_falta: DEFAULT_VALUE,
		})

		this.form.setFieldValue("tolerancia_extra", DEFAULT_VALUE);
		this.form.setFieldValue("tolerancia_falta", DEFAULT_VALUE);
	}

	onResetToleranciaBatidaExtraFalta = () => {
		this.form.setFieldValue("tolerancia_batida_extra", null);
		this.form.setFieldValue("tolerancia_batida_falta", null);
	}

	onChangeTipoHorario = (value) => {
		this.onChangeTolerancia({
			target: {
				checked: this.state.fixar_tolerancia,
			}
		});

		this.setState({
			tipo_horario: value,
		});
	}

	getIntervals = (tracks) => {
		let intervals = [];

		tracks[0]?.batida.forEach((batida, index) => {
			if(tracks[0].batida.length <= 1 || index === tracks[0].batida.length - 1) {
				return false;
			}

			intervals.push({
				id: Math.floor(Math.random() * 10001),
				title: "Saída " + (index + 1) + " / Entrada " + (index + 2),
				value: (index + 1) + "-" + (index + 2),
			});
		});

		this.setState({
			intervals: intervals,
		});

		this.updateSummary(tracks);
	}

	updateSummary = (tracks = this.table ? this.table.state.data : []) => {
		this.setState({ summary: getTracksSummary(tracks) });
	};

	resetFields = () => {
		this.setState({
			fixar_tolerancia: true,
			tolerancia_extra: 10,
			tolerancia_falta: 10,
			tipo_calculo: null,
			tipo_horario: 'semanal',
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		if (this.state.hasHourError) {
			message.error('Informe um horário válido no formato HH:mm.');
			return;
		}
		
		this.setState({
			isSending: true,
		});

		const data = { ...values };

		data.tolerancia_clt_art_58 = data.fixar_tolerancia;

		delete data.fixar_tolerancia;

		let tracks = [];

		if (data.tipo_calculo !== 'horista') {
			this.table.state.data.forEach((track) => {
				if (track.fechamento === null) {
					track.fechamento = 0;
				}

				tracks.push({ ...track, tipo_calculo: data.tipo_calculo })
			});

			data.diasemana = tracks;

			data.tolerencia_extra = data.tolerancia_extra;
			data.tolerencia_falta = data.tolerancia_falta;

			const hasValidTimePairing = data.diasemana.every(dia => 
        dia.batida.every(batida => {
					const entradaPreenchida = batida.entrada && batida.entrada.trim() !== '';
					const saidaPreenchida = batida.saida && batida.saida.trim() !== '';
					return entradaPreenchida === saidaPreenchida;
        })
   	 	);

			const allFieldsEmpty = data.diasemana.every(dia => 
				dia.batida.every(batida => {
					const entradaVazia = !batida.entrada || batida.entrada.trim() === '';
					const saidaVazia = !batida.saida || batida.saida.trim() === '';
					return entradaVazia && saidaVazia;
				})
			);
			
			if (!hasValidTimePairing || allFieldsEmpty) {
				this.setState({ isSending: false });
				message.error('Cadastre um par de horário, entrada e saída.');
				return;
			}
		} else {
			data.diasemana = []

			data.diasemana.push(
				{
					dia: null,
					folga: null,
					tipo_calculo: 'horista',
					duracao_escala: null,
					somar_total: null,
					tempo_mais_menos: null,
					tolerancia_hora_falta: null,
					tolerancia_hora_extra: null,
					tempo_mais_menos: null,
					carga_horaria: null,
					fechamento: data.fechamento,
					batida: null,
				},
			)
		}

		if (data.data_inicio_escala) {
			data.data_inicio_escala = moment(data.data_inicio_escala).format('YYYY-MM-DD');
		}

		timeService.create(data)
			.then(() => {
				this.setState({
					isSending: false,
				});

				// Reset fields
				this.resetFields();

				// Success message
				message.success("Horário cadastrado com sucesso.");

				// Callback
				this.props.onComplete();
			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	render() {
		const { visible } = this.props;

		const { isLoading, isSending, nextOrder, intervals, fixar_tolerancia, tipo_calculo, tipo_horario, tolerancia_extra, tolerancia_falta, dsr, dsrIsLoading, overtime, overtimeIsLoading, summary } = this.state;

		const isEscala = tipo_horario === "escala";

		return (
			<UIDrawerForm
				visible={visible}
				width={1200}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				icon={<i className="fal fa-clock" />}
				title="Incluir novo horário"
				subtitle="Preencha as informações para criar um novo horário de trabalho."
				btnSaveText="Salvar horário">
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}
					initialValues={{
						order: nextOrder,
						required: true,
						is_active: true,
						tolerancia_extra: 10,
						tolerancia_clt_art_58: true,
						tolerancia_falta: 10,
						fixar_tolerancia: true,
						tipo_horario: 'semanal',
						tracks_amount: 1,
					}}>
					<UIFormSection
						icon={<i className="fal fa-clipboard-list" />}
						title="Informações gerais"
						description="Identificação e regras de cálculo do horário.">
						<Row gutter={16}>
							<Col xs={24} md={10}>
								<Form.Item name="descricao" label="Descrição" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
									<Input ref={el => this.descricao = el} placeholder="Ex.: Horário administrativo" />
								</Form.Item>
							</Col>
							<Col xs={24} md={5}>
								<Form.Item name="status" label="Status" rules={[{ required: true, message: "Campo obrigatório." }]}>
									<Select
										optionFilterProp="children"
										filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
										allowClear
										showSearch
									>
										<Select.Option value="Ativo">Ativo</Select.Option>
										<Select.Option value="Inativo">Inativo</Select.Option>
									</Select>
								</Form.Item>
							</Col>
							<Col xs={24} md={9}>
								<Form.Item name="tipo_calculo" label="Tipo de cálculo" rules={[{ required: true, message: "Campo obrigatório." }]}>
									<Select
										optionFilterProp="children"
										filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
										onChange={(value) => this.setState({ tipo_calculo: value })}
										allowClear
										showSearch
										placeholder="Selecione o tipo de cálculo"
									>
										<Select.Option value="flexivel">Flexível</Select.Option>
										<Select.Option value="horista">Horista</Select.Option>
										<Select.Option value="intervalo_flexivel">Intervalo Flexível</Select.Option>
										<Select.Option value="normal">Normal</Select.Option>
									</Select>
								</Form.Item>
							</Col>
						</Row>
						{tipo_calculo != "horista" ? (
							<>
								<Row gutter={16}>
									<Col xs={24} md={6}>
										<Form.Item name="hora_extra_id" label="Hora extra" rules={[{ required: true, message: "Campo obrigatório." }]}>
											<Select
												filterOption={false}
												allowClear
												placeholder="Escolha a hora extra"
												notFoundContent={overtimeIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
												onDropdownVisibleChange={(open) => open && this.fetchOvertime()}
												onSearch={this.fetchOvertimeSearch}
												showSearch
											>
												{overtime.map((item, index) => (
													<Select.Option key={index} value={item.id}>
														{item.nome}
													</Select.Option>
												))}
											</Select>
										</Form.Item>
									</Col>
									<Col xs={24} md={6}>
										<Form.Item name="dsr_id" label="DSR">
											<Select
												filterOption={false}
												allowClear
												placeholder="Escolha o DSR"
												notFoundContent={dsrIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
												onDropdownVisibleChange={(open) => open && this.fetchDsr()}
												onSearch={this.fetchDsrSearch}
												showSearch
											>
												{dsr.map((item, index) => (
													<Select.Option key={index} value={item.id}>
														{item.nome}
													</Select.Option>
												))}
											</Select>
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item name="tipo_horario" label="Tipo de horário" rules={[{ required: true, message: "Campo obrigatório." }]}>
											<TimeTypeField onChange={this.onChangeTipoHorario} />
										</Form.Item>
									</Col>
								</Row>
								{isEscala && (
									<Row gutter={16}>
										<Col xs={24} md={6}>
											<Form.Item name="tipo_hora_escala" label="Tipo de hora escala" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
												<Select
													optionFilterProp="children"
													filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
													allowClear
													showSearch
													placeholder="Selecione"
												>
													<Select.Option value="12">12</Select.Option>
													<Select.Option value="24">24</Select.Option>
													<Select.Option value="36">36</Select.Option>
													<Select.Option value="48">48</Select.Option>
												</Select>
											</Form.Item>
										</Col>
										<Col xs={24} md={6}>
											<DatePickerWithMask label="Data base" name="data_inicio_escala" required={true} />
										</Col>
									</Row>
								)}
							</>
						) : (
							<Row gutter={16}>
								<Col xs={24} md={6}>
									<Form.Item name="fechamento" label="Fechamento">
										<Input />
									</Form.Item>
								</Col>
							</Row>
						)}
					</UIFormSection>
					{tipo_calculo != "horista" && (
						<>
							<UIFormSection
								icon={<i className="fal fa-stopwatch" />}
								title="Tolerâncias"
								description="Tolerâncias diárias de extras e faltas e pré-assinalação do intervalo.">
								<Form.Item name="fixar_tolerancia" valuePropName="checked">
									<Checkbox onChange={this.onChangeTolerancia}>
										Fixar tolerância de extras/faltas em 5 minutos e 10 minutos diários <Typography.Text type="secondary">(CLT - Art. 58)</Typography.Text>
									</Checkbox>
								</Form.Item>
								<Row gutter={16}>
									<Col xs={24} md={8}>
										<Form.Item name="tolerancia_extra" label="Tolerância extra" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
											<Input suffix="minutos" disabled={fixar_tolerancia} onBlur={(evt) => this.setState({ tolerancia_extra: evt.target.value })} />
										</Form.Item>
									</Col>
									<Col xs={24} md={8}>
										<Form.Item name="tolerancia_falta" label="Tolerância falta" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
											<Input suffix="minutos" disabled={fixar_tolerancia} onBlur={(evt) => this.setState({ tolerancia_falta: evt.target.value })} />
										</Form.Item>
									</Col>
									{intervals.length > 0 && (
										<Col xs={24} md={8}>
											<Form.Item name="intervalo_refeicao_sequencias" label="Pré assinalar intervalo">
												<Select
													optionFilterProp="children"
													filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
													allowClear
													showSearch
													placeholder="Selecione o intervalo"
												>
													{intervals.map((interval) => (
														<Select.Option key={interval.id} value={interval.value}>{interval.title}</Select.Option>
													))}
												</Select>
											</Form.Item>
										</Col>
									)}
								</Row>
								{!fixar_tolerancia && (
									<Row gutter={16}>
										<Col xs={24} md={8}>
											<Form.Item name="tolerancia_batida_extra" label="Tolerância antes" hasFeedback>
												<Input />
											</Form.Item>
										</Col>
										<Col xs={24} md={8}>
											<Form.Item name="tolerancia_batida_falta" label="Tolerância depois" hasFeedback>
												<Input />
											</Form.Item>
										</Col>
									</Row>
								)}
							</UIFormSection>
							<UIFormSection
								icon={<i className="fal fa-calendar-week" />}
								title={isEscala ? "Ciclos da escala" : "Dias da semana"}
								description={isEscala ? "Entradas, saídas e duração de cada ciclo da escala." : "Entradas, saídas e tolerâncias de cada dia da semana."}>
								<DayTable
									showOnly={false}
									onHourErrorChange={(hasError) =>
										this.setState({ hasHourError: hasError })
									}
									onChange={() => this.updateSummary()}
									ref={el => this.table = el}
									getIntervals={this.getIntervals}
									tipo_horario={tipo_horario}
									fixar_tolerancia={fixar_tolerancia}
									tipo_calculo={tipo_calculo}
									tolerancia_extra={tolerancia_extra}
									tolerancia_falta={tolerancia_falta}
								/>
							</UIFormSection>
							<TimeSummary
								summary={summary}
								isEscala={isEscala}
								toleranciaExtra={tolerancia_extra}
								toleranciaFalta={tolerancia_falta}
							/>
						</>
					)}
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Create;
